export const CURRENCY_MAPPER = {
  US: {
    host: 'amazon.com',
    currency: '$',
    timezone: 'America/Los_Angeles',
    icon: 'guoqi-us',
    name:'US'
  },
  UK: {
    host: 'amazon.co.uk',
    currency: '£',
    timezone: 'GMT',
    icon: 'guoqi-uk',
    name:'UK'

  },
  DE: {
    host: 'amazon.de',
    currency: '€',
    timezone: 'CET',
    icon: 'guoqi-de',
    name:'DE'
  },
  CA: {
    host: 'amazon.ca',
    currency: 'CA$',
    timezone: 'America/Los_Angeles',
    icon: 'guoqi-ca',
    name:'CA'
  },
  FR: {
    host: 'amazon.fr',
    currency: '€',
    timezone: 'CET',
    icon: 'guoqi-fr',
    name:'FR'
  },
}
export const COUNTRY_BASE = [
  {
    countryCode: 'US',
    host: 'amazon.com',
    currency: '$',
    icon: 'guoqi-us',
  },
  {
    countryCode: 'UK',
    host: 'amazon.co.uk',
    currency: '£',
    icon: 'guoqi-uk',
  },
  {
    countryCode: 'DE',
    host: 'amazon.de',
    currency: '€',
    icon: 'guoqi-de',
  },
  {
    countryCode: 'CA',
    host: 'amazon.ca',
    currency: 'CA$',
    icon: 'guoqi-ca',
  },
  {
    countryCode: 'FR',
    host: 'amazon.fr',
    currency: '€',
    icon: 'guoqi-fr',
  },
]

export const COUNTRY_SITE_CODE_MAP = {
  'amazon.com': 'US',
  'amazon.co.uk': 'UK',
  'amazon.de': 'DE',
  'amazon.ca': 'CA',
  'amazon.fr': 'FR',
}

export const CURRENCY_DATA_MAPPER = {
  'USD': '$',
  'GBP': '£',
  'EUR': '€',
  'CAD': 'CA$',
  'EUR': '€',
}

export const PAYPAL_FEE = {
  'US': '$0.49',
  'UK': '£0.39',
  'DE': '+€0.39',
  'FR': '+€0.39',
  'CA': 'CA$0.59',
}

export const AMAZON_CURRENCY_MAPPER = {
  'amazon.com': '$',
  'amazon.co.uk': '£',
  'amazon.de': '€',
  'amazon.ca': 'CA$',
  'amazon.fr': '€',
}
export const COUNTRY_BASE_ICON = {
  'US': 'guoqi-us',
  'UK': 'guoqi-uk',
  'DE': 'guoqi-de',
  'CA': 'guoqi-ca',
  'FR': 'guoqi-fr',
   'amazon.com': 'guoqi-us',
  'amazon.co.uk': 'guoqi-uk',
  'amazon.de': 'guoqi-ca',
  'amazon.ca': 'guoqi-ca',
  'amazon.fr': 'guoqi-fr',
}
export const statusInfo = {
  'pending': {
    text: 'Pending',
    type: 'pending',
    step:0
  },
  'declined': {
    text: 'Declined',
    type: 'declined',
    
  },
  'cancelled': {
    text: 'Canceled',
    type: 'cancelled',
    step:4
  },
  'accepted': {
    text: 'Accepted',
    type: 'accepted',
    step:1
  },
  'paid': {
    text: 'In Progress',
    type: 'paid',
    step:2
  },
  'confirming':{
    text: 'Confirming',
    type: 'confirming',
    step:3
  },
  'confirmed':{
    text:"Published",
    type:"confirmed",
    step:4
  },
  // 'published': {
  //   text: 'Published',
  //   type: 'published',
  // },
  'completed': {
    text: 'Payment Received',
    type: 'completed',
    step:6
  },
  'suspended': {
    text: 'Suspended',
    type: 'suspended',
    step:2
  },
  'draft':{
    text: 'Draft',
    type: 'draft',
  },
  'reviewing':{
    text: 'Pending Review',
    type: 'reviewing',
  },
 
  'rejected':{
    text: 'Rejected',
    type: 'Rejected',
  },
  'insufficient_stock':{
    text: 'Out of stock',
    type: 'insufficient_stock',
  },
  'offline':{
    text: 'Removed',
    type: 'offline',
  },
  'approved':{
    text: 'Approved',
    type: 'approved',
  },
 
}
export const COUNTRY_TIME_TZ = {
  'US': 'America/Los_Angeles',
  'UK': 'Europe/London',
  'DE': 'Europe/Berlin',
  'FR': 'Europe/Paris',
  'CA': 'America/Los_Angeles',
}

// 和存彬确认过
export const BILLING_TIME_TZ = {
  'amazon.com': 'America/Los_Angeles',
  'amazon.co.uk': 'Europe/London',
  'amazon.de': 'Europe/Berlin',
  'amazon.fr': 'Europe/Paris',
  'amazon.ca': 'America/Los_Angeles',
}

export const AMAZON_COUNTRY_TIME_TZ = {
  'amazon.com': 'America/Los_Angeles',
  'amazon.co.uk': 'Etc/GMT',
  'amazon.de': 'Europe/Berlin',
  'amazon.fr': 'Europe/Paris',
  'amazon.ca': 'America/Los_Angeles',
}
export const AMAZON_COUNTRY_TIME_AR = {
  'amazon.com': 'America/Los_Angeles',
  'amazon.co.uk': 'Europe/London',
  'amazon.de': 'Europe/Berlin',
  'amazon.fr': 'Europe/Paris',
  'amazon.ca': 'America/Los_Angeles',
}
export const COUNTRY_COMMISSION_TXT = {
  'US': "Commissions are locked for a given day at 11:59 pm Pacific Time (PT) the night before. The current commission value will become tomorrow's locked-in commission value at that time. ",
  'UK': "Commissions are locked for a given day at 11:59 pm Greenwich Mean Time Zone (GMT) the night before. The current commission value will become tomorrow's locked-in commission value at that time. ",
  'DE': "Commissions are locked for a given day at 11:59 pm Central European Time Zone (CET) the night before. The current commission value will become tomorrow's locked-in commission value at that time. ",
  'FR': "Commissions are locked for a given day at 11:59 pm Central European Time Zone (CET) the night before. The current commission value will become tomorrow's locked-in commission value at that time. ",
  'CA': "Commissions are locked for a given day at 11:59 pm Pacific Time (PT) the night before. The current commission value will become tomorrow's locked-in commission value at that time. ",
}
